import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import BusinessIcon from '@mui/icons-material/Business'
import DashboardIcon from '@mui/icons-material/Dashboard'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import StorageIcon from '@mui/icons-material/Storage'

import { routeBackOfficeAdminToolsCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAdminToolsCommon'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Routes backoffice du Store CS-CART (centrale d'achat) — distinct du Store PLV
 * (ex-StoreBag, fichier {@link getBackOfficeStoreBagAdmin}, entite PHARMEDISTOREBAG).
 * Première entrée de menu du rôle ROLE_DYNAMIC_ROUTE_STORE_ADMIN, jusqu'ici absent
 * de tous les fichiers de routes.
 */
const getBackOfficeStoreCscartAdmin = [
  {
    route: 'StoreCscartDashboard',
    text: 'Tableau de bord Store',
    t: 'routes.backoffice.store.dashboard',
    icon: DashboardIcon,
    href: '/backoffice/store/dashboard',
    menuHeader: true,
    position: 12,
  },
  {
    // Logistique Store, deux entrepôts (front#771) : commandes à expédier de TOUS les vendeurs de la
    // logistique (Pharmedistore, dépositaires, déstockage, matériel Sound), choix d'Azay ou d'Athée,
    // expédition et étiquette DPD. Espace Pharmedigroup (pas de `space`) : la page parle de la
    // logistique de Pharmedistore, pas d'un laboratoire. Seule entrée du menu ouverte au profil
    // « Logistique Store » (rôles posés ci-dessous, pas dans le `.map`).
    route: 'StoreLogistics',
    text: 'Logistique Store',
    t: 'routes.backoffice.store.logistics',
    icon: LocalShippingIcon,
    href: '/backoffice/store/logistics',
    menuHeader: true,
    position: 16,
    roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_ADMIN, CONSTANTS.ROLE_STORE_LOGISTICS],
  },
  {
    // Aide à la fiche produit : l'IA propose rayon, marque, gamme et description, tous vendeurs
    // confondus, et l'administrateur Store valide. Espace Pharmedigroup (pas de `space`) : la page
    // parle du catalogue de la boutique. Store étant fermé hors de France, ENTITY_COUNTRIES suffit.
    route: 'StoreProductEnrichment',
    text: 'Qualité des fiches produit',
    t: 'routes.backoffice.store.productEnrichment',
    icon: AutoAwesomeIcon,
    href: '/backoffice/store/product-enrichment',
    menuHeader: true,
    position: 17,
  },
  {
    // Reprise LAP : la base de l'outil LAP n'est joignable qu'en SSH, depuis un poste. Son export (CSV)
    // est déposé ici et appliqué à la boutique (laboratoires, marques). Super admin seulement.
    route: 'StoreLapImport',
    text: 'Import de la base LAP',
    t: 'routes.backoffice.store.lapImport',
    icon: StorageIcon,
    href: '/backoffice/store/lap-import',
    menuHeader: true,
    position: 18,
    roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN],
  },
  {
    // Annuaire d'un admin Store : les entreprises (industrie) actives sur le Store. Les pharmacies
    // n'y sont pas, et la liste complète reste celle des autres rôles admin (`CompanyList`).
    route: 'CompanyListStore',
    menuGroup: MENU_GROUPS.DIRECTORY,
    text: 'Entreprises Store',
    t: 'routes.backoffice.store.companies',
    icon: BusinessIcon,
    href: '/backoffice/common/company/company-list-store',
    menuHeader: true,
    position: 152,
  },
  {
    // Fiche ouverte depuis cette liste : sans cette entrée, un admin Store serait renvoyé à l'accueil.
    route: 'editCompany',
    text: 'Edition établissement',
    href: '/backoffice/common/company/edit-company/[companyId]',
    menuHeader: false,
  },
  ...routeBackOfficeAdminToolsCommon,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISTORE],
  // Une entrée qui déclare ses rôles les garde (Logistique Store) ; les autres restent aux admins Store.
  roles: 'roles' in route && route.roles ? route.roles : [CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_ADMIN],
}))

export default getBackOfficeStoreCscartAdmin
